import React from "react";
import { Label, FindInputButton } from "src/components";
import { SelectedClubType } from "src/types";
import styled from "styled-components";

interface Step3ClubSelectionProps {
  TeamRadioBoxGroup: React.ComponentType<any>;
  selectedTeamCountIds?: number[];
  selectedClubs?: SelectedClubType[];
  setSelectedClubs: (clubs: SelectedClubType[]) => void;
  setCurrentClubPreferenceNumber: (number: number) => void;
  openClubSearchPopup: () => void;
  alert: any;
  onCancel?: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
}

export default function Step3ClubSelection({
  TeamRadioBoxGroup,
  selectedTeamCountIds: _selectedTeamCountIds,
  selectedClubs,
  setSelectedClubs: _setSelectedClubs,
  setCurrentClubPreferenceNumber,
  openClubSearchPopup,
  alert,
  onCancel: _onCancel,
  onNext,
  onPrevious: _onPrevious,
}: Step3ClubSelectionProps) {
  return (
    <ST3Container>
      {/* Main Content */}
      <div className="main-content">
        {/* Step3: 골프장 선택 섹션 */}

        <h1 className="page-title">희망 골프장3개를 선택해주세요.</h1>
        <div className="step3-section">
          <TextCaption>
            <Label className="bold" content="골프장 선택" isEssential={true} />
            <caption>(2개 이상)</caption>
          </TextCaption>
          <FindInputButton
            // label="1"
            tabIndex={1}
            id={"club-section"}
            // required={true}
            selectedName={selectedClubs?.filter((c) => c.preference === 1)[0]?.name ?? ""}
            onClick={() => {
              setCurrentClubPreferenceNumber(1);
              openClubSearchPopup();
            }}
          />
          <FindInputButton
            // label="2"
            // required={true}
            selectedName={selectedClubs?.filter((c) => c.preference === 2)[0]?.name ?? ""}
            onClick={() => {
              if (!(selectedClubs && selectedClubs.some((club) => club.preference === 1))) {
                alert({ content: "1지망 골프장을 선택하세요." });
                return;
              }
              setCurrentClubPreferenceNumber(2);
              openClubSearchPopup();
            }}
          />
          <FindInputButton
            // label="3"
            // required={false}
            selectedName={selectedClubs?.filter((c) => c.preference === 3)[0]?.name ?? ""}
            onClick={() => {
              if (!(selectedClubs && selectedClubs.some((club) => club.preference === 2))) {
                alert({ content: "1, 2지망 골프장을 선택하세요." });
                return;
              }
              setCurrentClubPreferenceNumber(3);
              openClubSearchPopup();
            }}
          />
        </div>

        {/* Step1: 팀수 선택 섹션 */}
        <div className="step1-section">
          <div className="form-section">
            <div className="field-label">
              <TextCaption>
                <span className="required-asterisk">*</span>
                <span className="label-text">신청 팀수</span>
                <caption>(라운드 예정 팀)</caption>
              </TextCaption>
            </div>

            <div className="input-field">
              <TeamRadioBoxGroup />
            </div>
          </div>
        </div>

        {/* Bottom Navigation */}
        <div className="bottom-nav">
          <div className="button-group">
            {/* {onPrevious && (
              <button className="previous-button" onClick={onPrevious}>
                뒤로
              </button>
            )} */}
            <button
              className="next-button"
              onClick={onNext}
              disabled={
                !selectedClubs ||
                selectedClubs.length < 2 ||
                !_selectedTeamCountIds ||
                _selectedTeamCountIds.length === 0
              }
            >
              다음
            </button>
          </div>
        </div>
      </div>
    </ST3Container>
  );
}

const ST3Container = styled.div`
  :root {
    --teeshot-white: #fdfdfd;
    --teeshot-black: #1a1a1a;
    --teeshot-gray-2: #d1d5d8;
    --teeshot-gray-3: #f0f0f4;
    --teeshot-gray-1: #79818a;
    --teeshot-active: #007bff;
  }

  padding: 16px;
  width: 100%;
  background: var(--teeshot-white);
  position: relative;

  font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
  overflow-y: auto;

  /* Main Content */
  .main-content {
    left: 16px;
    top: 10px;
    height: auto;
    padding-bottom: 120px; /* 하단 버튼 공간 확보 */
  }

  /* Step3 Section */
  .step3-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 40px;
  }

  /* Step1 Section */
  .step1-section {
    margin-bottom: 40px;
  }

  .page-title {
    color: var(--teeshot-black);
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin: 0 0 20px 0;
    margin-top: 8px;

    height: 24px;
  }

  .form-section {
    margin-bottom: 40px;
  }

  .field-label {
    margin-bottom: 12px;
    height: 18px;
  }

  .required-asterisk {
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #f97000;
  }

  .label-text {
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: var(--teeshot-black);
  }

  .input-field {
    width: 100%;
  }

  /* Bottom Navigation */
  .bottom-nav {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 26px 16px;
    background: linear-gradient(0deg, #fdfdfd 0%, #fdfdfd 60%, rgba(253, 253, 253, 0.3) 85%, rgba(253, 253, 253, 0) 100%);
    backdrop-filter: blur(10px);
    z-index: 0;
    display: flex;
    gap: 8px;
  }

  .button-group {
  padding-bottom: 24px;
    display: flex;
    gap: 12px;
    width: 100%;
  }

  .previous-button {
    display: flex;
    width: 100%;
    max-width: 400px;
    min-width: 170px;
    height: 60px;
    padding: 19px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    background: var(--Teeshot-Primary-Color-Teeshot-Green, #004b49);
    color: white;
    border: none;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .previous-button:hover {
    background-color: #003a38;
  }

  .previous-button:active {
    background-color: #002a28;
  }

  .next-button {
    display: flex;
    width: 100%;
    max-width: 400px;
    min-width: 170px;
    height: 60px;
    padding: 19px 20px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    background: var(--Teeshot-Primary-Color-Teeshot-Green, #004b49);
    color: white;
    border: none;
    font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .next-button:hover {
    background-color: #003a38;
  }

  .next-button:active {
    background-color: #002a28;
  }

  .next-button:disabled {
    background-color: #d1d5d8;
    color: #79818a;
    cursor: not-allowed;
  }

  .caption {
    font-size: 12px;
    color: var(--teeshot-gray-1);
  }
}
`;

const TextCaption = styled.div`
  display: flex;
  align-items: center;

  caption {
    font-size: 12px;
    color: var(--teeshot-gray-1);
    margin-left: 4px;
  }
`;
